import React,{useState,useEffect} from 'react'
import "./vendor.css"
import create_vendor from "../../../assets/audit_assets/Audit_vendor/create_vendor.png"
import login_release from "../../../assets/audit_assets/Audit_vendor/login_release.png"
import filestemp from "../../../assets/templates/audit_template/Vendor_Template.xlsx"
import file_upload_icon from "../../../assets/audit_assets/Audit_vendor/file_upload_icon.png"
import file_uploaded_icon from "../../../assets/audit_assets/Audit_vendor/file_uploaded_icon.png"
import into from "../../../assets/audit_assets/Audit_vendor/into.png"
import { GoChevronRight } from "react-icons/go";
import download_template from '../../../assets/reUsableTemplates_assets/download_template.png';
import intomarkIcon from "../../../assets/audit_assets/Audit_vendor/intomarkIcon.png"
import Editble_table from '../audit_reuseble_tables/editble_table'
import {getVendor,updateVendorById,deleteVendorById,multiDeleteVendor,uploadVendorFile,createSingleVendor,vendorLoginRelease} from "../../../services/audit_redux/audit_actions/vendor.action"
import { getUnits } from '../../../services/global_redux/globale_actions/Unit.action';
import { getClients} from '../../../services/global_redux/globale_actions/Client.action';
import branch_icon from "../../../assets/audit_assets/Audit_vendor/branch_icon.png"
import client_icon from "../../../assets/audit_assets/Audit_vendor/client_icon.png"
import main_id_icon from "../../../assets/audit_assets/Audit_vendor/main_id_icon.png"
import phone_number_icon from "../../../assets/audit_assets/Audit_vendor/phone_number_icon.png"
import status_icon from "../../../assets/audit_assets/Audit_vendor/status_icon.png"
import vendor_name_icon from "../../../assets/audit_assets/Audit_vendor/vendor_name_icon.png"
import mainicon from "../../../assets/audit_assets/Audit_vendor/vendor_main_icon.png"
import { useDispatch } from 'react-redux';
import { getUserRole } from "../../../services/global_redux/globale_actions/Role.action";
import Select, { components } from "react-select";
import { data } from 'jquery'
// import { Select } from '@mui/material'
function Vendor({showSnackbar ,setLoading}) {
  const [getData, setGetData] = useState(null);
  const [file, setFile] = useState(null);
  const [filemain, setFilemain] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const [editableRow, setEditableRow] = useState(null);
  const [editedValues, setEditedValues] = useState({})
  const [createSingleView, setCreateSingleView] = useState(false);
  const [loginReleaseView, setLoginReleaseView] = useState(false);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [clientID,setClientID] = useState([])
  const [unitID,setUnitID] = useState([])
  const dispatch = useDispatch();
  const [selectedclient, setSelectedclient] = useState("");
  const [filteredData, setFilteredData] = useState(getData);
  const [createData, setCreateData] = useState(null);
  const [editData, setEditData] = useState(null);
  const [deleteData, setDeleteData] = useState(null);
  const [actionChecked, setActionChecked] = useState("");
  const addSingleData = {
    client_id:"",
    unit_id:[],
    vendor_name:"",
    vendor_address:"",
    owner_name:"",
    owner_designation:"",
    spoc_name:"",
    spoc_email:"",
    spoc_mobile:"",
    esi_no:"",
    pf_no:"",
    se_no:"",
    role_name:"vendor",
  }
  const [formData, setFormData] = useState(addSingleData);
  const createVendorNames = [
    { key: "client_id", value: "Organization Name",input:'select',required:true},
    { key: "unit_id", value: "Branches",input:'select',required:true},
    { key: "vendor_name", value: "Vendor Name",input:'text',required:true},
    { key: "vendor_address", value: "Vendor Address",input:'text',required:true},
    { key: "owner_name", value: "Authorised Signatory Name",input:'text',required:true},
    { key: "owner_designation", value: "Authorised Signatory designation",input:'text',required:true},
    { key: "spoc_name", value: "SPOC Name",input:'text',required:true},
    { key: "spoc_email", value: "SPOC Email ID",input:'email',required:true},
    { key: "spoc_mobile", value: "SPOC Phone No",input:'text',required:true},
    { key: "esi_no", value: "ESI No",input:'text',required:false},
    { key: "pf_no", value: "PF No",input:'text',required:false},
    { key: "pt_no", value: "PT No",input:'text',required:false},
    { key: "se_no", value: "S&E No",input:'text',required:true}
  ]
  const header = [
    { key: "vendor_name", value: "Vendor Name", input: "text", icon: vendor_name_icon, dataIcon: false, highlightName: false ,readOnly:true},
    { key: "spoc_mobile", value: "SPOC Phone Number", input: "text", icon: phone_number_icon, dataIcon: false, highlightName: false ,readOnly:false },
    { key: "spoc_email", value: "SPOC Email ID", input: "email", icon: main_id_icon, dataIcon: false, highlightName: false ,readOnly:false },
    { key: "client_id", value: "Organization ID", input: "text", icon: client_icon, dataIcon: false, highlightName: false ,readOnly:true },
    { key: "unit_id", value: "Branch ID", input: "text", icon: branch_icon , dataIcon: false, highlightName: false ,readOnly:true},
    { key: "status", value: "Status", input: "text", icon: status_icon , dataIcon: false, highlightName: true ,readOnly:true}
  ];

  const fetchdata = async () =>{
    setLoading(true);
    try{
      const response = await dispatch(getVendor());
      if (response.data) {
        setLoading(false);
          const withBranchIds = (item) => ({
            ...item,
            unit_id: item.unit_id
              ? (Array.isArray(item.unit_id) ? item.unit_id : JSON.parse(item.unit_id)).join(", ")
              : "",
          });
          setGetData(response.data.map(withBranchIds));
          setFilteredData(response.data.map(withBranchIds));
      }else{
        setLoading(false);
        setGetData([]);
      } 
    }catch(err){
      setLoading(false);
      setGetData([]);
      console.error("Failed to fetch clients:", err);

    }

  }
  useEffect (()=>{
    fetchdata();
  },[dispatch])
  
  const getUserPermission = async () => {
    try {
        const response = await dispatch(getUserRole());    
        const rawPermissions = response?.data?.permissions;

        const parsedPermissions = typeof rawPermissions === "string"
            ? JSON.parse(rawPermissions)
            : Array.isArray(rawPermissions) && typeof rawPermissions[0] === "string"
                ? JSON.parse(rawPermissions[0])
                : rawPermissions;
                parsedPermissions.forEach((item) => {
                  if (item.section == "Audit" && item.module == "Vendor") {
                    if(item.action.edit){
                      setEditData(true);
                    }
                    setCreateData(item.action.create);
                    setDeleteData(item.action.delete);
        }});
    } catch (err) {
        console.error("Failed to fetch permissions:", err);
    }
};

useEffect (()=>{
  getUserPermission();
},[dispatch])
  const filterClinetWiseData = (event) => {
    const value = event.target.value;
    setSelectedclient(value);
  
    if (value === "") {
      setFilteredData(getData); 
    } else {
      setFilteredData(getData.filter(item => item.client_id === value));
    }
  };
const fetchAllClient = async () => {
  try {
      const response = await dispatch(getClients());
      if (response.data) {
            setClientID(response.data);
      }
  } catch (err) {
      console.error("Failed to fetch clients:", err);
  }
}
const selected_client = async (id) => {
  setFormData((prev) => ({
    ...prev,
    client_id: id,
    unit_id: [],
  }));

  if (!id) {
    setUnitID([]);
    return;
  }
  try {
      const response = await dispatch(getUnits(id));
      console.log(response);
      if (response.data) {
            setUnitID(response.data);
      }else{
        setUnitID([]);
      }
  } catch (err) {
      console.error("Failed to fetch clients:", err);
  }
}
const handleUnitChange = (selectedOptions) => {
  const unitIds = selectedOptions ? selectedOptions.map((u) => u.value) : [];
  setFormData((prev) => ({
    ...prev,
    unit_id: unitIds,
  }));
};
useEffect(() => {
        fetchAllClient();
  }, [dispatch]);
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if(selectedFile === undefined){
      setFile(null);
      setFilemain(null);
      return;

    }else{
      if (!selectedFile.name.match(/\.(xls|xlsx)$/i)) {
        if(selectedFile !== undefined){
          alert("Only Excel files are allowed");
        }
        return;
      }else{
        setFile({
          name: selectedFile.name,
          size: (selectedFile.size / (1024 * 1024)).toFixed(2) + " MB",
        });
        setFilemain(selectedFile);
        e.target.value = "";
      }

    }
  };
  const removeFile = () => {
    setFile(null);
    setFilemain(null);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const droppedFile = e.dataTransfer.files[0];
      if (!droppedFile.name.match(/\.(xls|xlsx)$/i)) {
        alert("Only Excel files are allowed");
        return;
      }else{
        setFilemain(droppedFile);
        setFile({
          name: droppedFile.name,
          size: (droppedFile.size / (1024 * 1024)).toFixed(2) + " MB",
        });
      }
    }
  };
  const handleFileUpload = async () => {
    if (file) {
        setLoading(true);
        try {
            const response = await dispatch(uploadVendorFile(filemain));
            if (response.success == true) {
                showSnackbar(response.message.message, 'success');
                setLoading(false);
                fetchdata();
                setFile(null);
                setFilemain(null)
                setActionChecked("create");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
                setActionChecked("create");
                fetchdata();
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    }
};
  const handleSubmit = (e) => {
    e.preventDefault(); 
    if (!file) {
      alert("no file");
      return;
    }else{
      handleFileUpload()
    }
  };
  useEffect(()=>{
    if(File === null){
      setFile(File);
    }
  },[File]) 
  
  const handledeleteClickOpenalert = async (id) => {
    setLoading(true);
    try {
      const response = await dispatch(deleteVendorById(id));
      if (response.success == true) {
        showSnackbar(response.message, 'success');
        setLoading(false);
        setEditableRow(null);
        setActionChecked("delete");
        fetchdata();
      } else {
        showSnackbar(response.message, 'warning');
        setLoading(false);
      }
    } catch (error) {
      showSnackbar('An error occurred', 'error');
      setLoading(false);
    }
  };
  
  const submitdelete = async (id) => {
    setLoading(true);
    try {
      const response = await dispatch(multiDeleteVendor(id));
      if (response.success == true) {
        showSnackbar(response.message.message, 'success');
        setLoading(false);
        setActionChecked("delete");
        fetchdata();
        
      } else {
        showSnackbar(response.message, 'warning');
        setLoading(false);
      }
    } catch (error) {
      showSnackbar('An error occurred', 'error');
      setLoading(false);
    }

  }
  const handleSaveClick = async (e) => {
    const mobile = editedValues.spoc_mobile?.trim();
      const mobileRegex = /^\+?[1-9]\d{6,14}$/;
      
      if (!mobile){
        showSnackbar("SPOC Phone No cannot be empty", "warning");
        return;
      }
      else if (!mobileRegex.test(mobile)) {
        showSnackbar("Enter a valid SPOC Phone No", "warning");
        return;
      }
    const email = editedValues.spoc_email?.trim();

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!email) {
        showSnackbar("Mail ID cannot be empty", "warning");
        return;
      } 
      else if (!emailRegex.test(email)) {
        showSnackbar("Please enter a valid Mail ID", "warning");
        return;
      }else{
      setLoading(true);
      try {
        const response = await dispatch(updateVendorById(editedValues.id, editedValues));
        if (response.success == true) {
          showSnackbar(response.message, 'success');
          setLoading(false);
          setEditableRow(null);
          fetchdata();
        } else {
          showSnackbar(response.message, 'warning');
          setLoading(false);
        }
      } catch (error) {
        showSnackbar('An error occurred', 'error');
        setLoading(false);
      }
    }
  };
  
  const handleToggleCreateSingleView= () => {
    setCreateSingleView(!createSingleView);
  };
  const handleToggleReleaseLogin= () => {
    setLoginReleaseView(!loginReleaseView);
  };

const handleFormSubmit = async (e) => {
  e.preventDefault();
  const nameRegex = /^[a-zA-Z\s]+$/;
  const name = formData.spoc_name?.trim();

  if (!nameRegex.test(name)) {
    showSnackbar("Enter a valid SPOC Name", "warning");
    return;
  }
  const vendorName = formData.vendor_name?.trim();
  if (!vendorName) {
    showSnackbar("Vendor Name cannot be empty", "warning");
    return;
  }
  else if (!nameRegex.test(vendorName)) {
    showSnackbar("Enter a valid Vendor Name", "warning");
    return;
  }

  const mobile = formData.spoc_mobile?.trim();

  // Allows + followed by 7–15 digits (global standard)
  const mobileRegex = /^\+?[1-9]\d{6,14}$/;

if (!mobileRegex.test(mobile)) {
  showSnackbar("Enter a valid SPOC Phone No", "warning");
  return;
}
const esi_no = formData.esi_no?.trim();
const esiRegex = /^\d{10,17}$/;

if (esi_no && !esiRegex.test(esi_no)){
  showSnackbar("Enter a valid ESI No 10 to 17 digits", "warning");
  return;
}
const pf_no = formData.pf_no?.trim();
const pfRegex =/^[A-Z]{2}\/[A-Z]{3}\/\d{4}\/\d{7}$/;
if (pf_no && !pfRegex.test(pf_no)){
  showSnackbar("Enter a valid PF number (e.g., KN/BNG/1234/0001234)", "warning");
  return;
}
const pt_no = formData.pt_no?.trim();
const ptRegex = /^[A-Za-z0-9]{8,20}$/;
if (pt_no && !ptRegex.test(pt_no)){
  showSnackbar("Enter a valid PT number (8 to 20 alphanumeric characters)", "warning");
  return;
}
const se_no = formData.se_no?.trim();
const seRegex = /^[A-Za-z0-9/-]{5,25}$/;
if (!se_no){
  showSnackbar("S&E No cannot be empty", "warning");
  return;
}else if (!seRegex.test(se_no)){
  showSnackbar("Enter a valid S&E number (5 to 25 characters, alphanumeric, / or -)", "warning");
  return;
}
  try {
  const response = await dispatch(createSingleVendor(formData))
  if(response.success){
    showSnackbar(response.message.message, 'success');
    setFormData(addSingleData);
    setCreateSingleView(false)
    setActionChecked("create");
    fetchdata();
  }else{
    showSnackbar(response.message, 'warning');
  }
} catch (error) {
  showSnackbar('An error occurred', 'error');
  setLoading(false);
}
}
const handleChange = (e) => {
  const { name, value } = e.target;
  const trimmedValue = value.trim();
  setFormData((prev) => ({
    ...prev,
    [name]: trimmedValue,
  }));
};
const handleKeyDown = (e) => {
  if (e.key === " " && e.target.value.length === 0) {
    e.preventDefault();
  }
};

  const MultiValueContainer = ({ getValue }) => {
    const values = getValue();
    return (
      <div
        style={{
          fontSize: "13px",
          color: "#333",
          whiteSpace: "normal",
          wordWrap: "break-word",
          overflow: "hidden",
          textOverflow: "ellipsis",
          lineHeight: "1.2",
        }}
      >
        {values.map((v) => v.label).join(", ")}
      </div>
    );
  };
  
  const handleSelect = (vendorId) => {
    setSelectedVendors((prev) =>
      prev.includes(vendorId)
        ? prev.filter((id) => id !== vendorId)
        : [...prev, vendorId]
    );
  };
  const handleSelectAll = () => {
    if (selectedVendors.length === getData.length) {
      setSelectedVendors([]);
    } else {
      setSelectedVendors(getData.map((v) => v.id));
    }
  };
  const handleSingleRelease = async (row) => {
  
    const payload = {
      ids: [row],
    };
    LoginRelease(payload);

  };
  const handleBulkRelease = async () => {
    const payload = {
      ids: selectedVendors,
    };
    LoginRelease(payload);
  };

  const LoginRelease = async (ids)=>{
    setLoading(true);
    try {
      const response = await dispatch(vendorLoginRelease(ids));
      if (response.success) {
        showSnackbar(response.message, 'success');
        setLoading(false);
        setEditableRow(null);
        fetchdata();
        setSelectedVendors([]);
      } else {
        showSnackbar(response.message, 'warning');
        setLoading(false);
      }
    } catch (error) {
      showSnackbar('An error occurred', 'error');
      setLoading(false);
    }
  }
  
      
  return (
    <div className='vendor-contaier'>
      <h5 className='text-white title'>Vendor</h5>
      <div className="vendor-file-upload">
        {createData && 
          <div className="row">
            <div className="col-md-6">
              <div className="col-md-12 upload-vendor-maincontainer">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-md-12 d-flex FormsImportFile-title-vendor">
                            <div className="col ">
                            <h5>Import Vendor</h5>
                            <p className='p-0 m-0'>Add your documents here</p>
                            </div>
                            
                            
                            <div className="col"><a href={filestemp} download="Vendor_Template.xlsx" className='float-end template-btn me-2'><img src={download_template} alt="" /><span>Template</span></a></div>

                        </div>
                    </div>
        
                    <div className="row FormsImportFile-upload-vendor">
                        <div className="upload-box-main-vendor ">
                        <div
                            className={`upload-box d-flex align-items-center justify-content-between ${
                            dragActive ? "drag-active" : ""
                            }`}
                            onDragOver={(e) => {
                            e.preventDefault();
                            setDragActive(true);
                            }}
                            onDragLeave={() => setDragActive(false)}
                            onDrop={handleDrop}
                        >
                            <div className="d-flex align-items-center">
                            <div className="upload-icon me-2">
                                <img src={file_upload_icon} alt="no img" />
                            </div>
                            <div>
                                <p className="p-0 m-0">
                                {dragActive ? "Drop file here" : "Select a file or drag and drop here"}
                                </p>
                                <small className="text-muted">
                                Only supports .xlsx
                                </small>
                            </div>
                            </div>
                            <a
                            onClick={() => document.getElementById("fileInput").click()}
                            >
                            SELECT FILE
                            </a>
                            <input
                            type="file"
                            id="fileInput"
                            className="d-none"
                            onChange={handleFileChange}
                            accept=".xls,.xlsx"
                            />
                        </div>
                        </div>

                        {file && (
                        <div className="uploaded-box-main-vendor p-0 m-0">
                            <div className="uploaded-file d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <img src={file_uploaded_icon} alt="no img" />
                                <div>
                                <p className="mb-0 uploaded-file-name">{file.name}</p>
                                <small className="text-muted uploaded-file-size">{file.size}</small>
                                </div>
                            </div>
                            <a
                                className="close-btn p-0"
                                onClick={removeFile}
                            >
                                <img src={into} alt="noImg" />
                            </a>
                            </div>
                        </div>
                        )}
                    </div>
                    <button className="upload-file-submit-btn">Submit</button>
                </form>
              </div>
            </div>
            <div className="col-md-3 vendor-card vendor-card-data-1">
              <div>
                <div className="img-div">
                  <img src={create_vendor} alt="" />
                </div>
                <div className="vendor-card-header">
                  <h4>Create Single Vendor</h4>
                  <p>Add and manage an individual vendor with complete details.</p>
                  <button onClick={handleToggleCreateSingleView} >Create Now <span><GoChevronRight /></span></button>
                </div>
              </div>
            </div>
            <div className="col-md-3 vendor-card vendor-card-data-2">
              <div>
                <div className="img-div">
                  <img src={login_release} alt="" />
                </div>
                <div className="vendor-card-header">
                  <h4>Login Release</h4>
                  <p>Vendor access details will be shared through email.</p>
                  <button onClick={handleToggleReleaseLogin}>Release Login's <span><GoChevronRight /></span></button>
                </div>
              </div>
            </div>          
          </div>
        }
      </div>

    <div className="row px-3">
      <Editble_table
        header={header}
        mainIcon={mainicon}
        title={'Vendor'}
        data={filteredData}
        setEditableRow={setEditableRow}
        setEditedValues={setEditedValues}
        handledeleteClickOpenalert={handledeleteClickOpenalert}
        editableRow={editableRow}
        setLoading={setLoading}
        editedValues={editedValues}
        getEditPermission = {editData}
        getDeletePermission = {deleteData}
        date={null}
        submitdelete={submitdelete}
        handleSaveClick={handleSaveClick}
        showSnackbar={showSnackbar}
        mainIconColor={"#c9dcff"}
        tableHeaderColor={"#edf3ff"}
        tableHeaderTextColor={"#2d2be2"}
        actionChecked={actionChecked}
        setActionChecked={setActionChecked}
        createOrfilterComp=
          {getData &&
            <select className="formsTable_select_dropdown" value={selectedclient}  onChange={filterClinetWiseData} >
          <option value="" className='bg-light text-dark'>All Organization</option>
          {[...new Map(getData.map(item => [item.client_id, item])).values()]?.map((item, index) => (
            <option key={index} value={item.client_id} className='bg-light text-dark'>{item.client_name}</option>
          ))}
        </select>}
        
      />
    </div>
    {createSingleView && (
      <>
          <div className="vendorAddSingleMainContainer"></div>
          <div className="vendorAddSingleMainContainer-module shadow ">
              <div className="create-vendor-forms-header d-flex justify-content-between">
                  <div className="div">
                      <h5>Create Single Vendor</h5>
                      <p>Add and manage an individual vendor with complete details</p>
                  </div>
                  <div>
                  <button
                      className="into-btn-icon"
                      onClick={() => setCreateSingleView(false)}
                  >
                      <img src={intomarkIcon} alt="" />
                  </button>
                  </div>
              </div>
              <div className="vendor-form-main-div">
                  <div className="container mt-2">
                    <div className="form-container">
                      <form onSubmit={handleFormSubmit}>
                        <div className="row">
                            <div className="col-md-12">
                              <div className="row">
                                {createVendorNames.map((item) =>
                                  item.value === "Authorised Signatory Name" ||
                                  item.value === "Authorised Signatory designation" ? (
                                    <div className="col-md-12" key={item.key}>
                                      <label className="form-label" htmlFor={item.key}>
                                        {item.value} {item.required && <span className="text-danger">*</span>}
                                      </label>
                                        <input className="form-control" name={item.key} type={item.input}  value={formData[item.key] || ""}
                                          onChange={handleChange} required={item.required} onKeyDown={handleKeyDown}/>
                                    </div>
                                  ) : (
                                    <div className="col-md-6" key={item.key}>
                                      <label className="form-label" htmlFor={item.key}>
                                        {item.value} {item.required && <span className="text-danger">*</span>}
                                      </label>

                                      {item.key === "unit_id" ? (
                                        <>
                                          <Select
                                            isMulti
                                            isDisabled={!formData.client_id}
                                            options={unitID.map((u) => ({
                                              value: u.unit_id,
                                              label: u.unit_id,
                                            }))}

                                            value={unitID
                                              .filter((u) => formData.unit_id.includes(u.unit_id))
                                              .map((u) => ({
                                                value: u.unit_id,
                                                label: u.unit_id,
                                              }))}

                                            onChange={(selected) => {
                                              const selectedValues = selected.map((s) => s.value);
                                              setFormData({
                                                ...formData,
                                                unit_id: selectedValues,
                                              });
                                            }}

                                            placeholder={
                                              formData.client_id
                                                ? "Select one or more units"
                                                : "Select org first"
                                            }

                                            menuPortalTarget={document.body}

                                            styles={{
                                              menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 999999,
                                              }),

                                              control: (provided) => ({
                                                ...provided,
                                                minHeight: "38px",
                                                fontSize: "14px",
                                                borderColor: "#ced4da",
                                                boxShadow: "none",
                                                "&:hover": { borderColor: "#86b7fe" },
                                              }),

                                              valueContainer: (provided) => ({
                                                ...provided,
                                                flexWrap: "wrap",
                                                maxHeight: "40px",
                                                overflowY: "auto",
                                              }),

                                              menu: (provided) => ({
                                                ...provided,
                                                zIndex: 999999,
                                                maxHeight: "200px",
                                                overflowY: "auto",
                                                position: "absolute",
                                              }),

                                              menuList: (provided) => ({
                                                ...provided,
                                                maxHeight: "200px",
                                                overflowY: "auto",
                                              }),
                                            }}

                                            required={item.required}
                                          />
                                        </>
                                      ) : item.key === "client_id" ? (
                                        <select
                                          className="form-select"
                                          onChange={(e) => selected_client(e.target.value)}
                                          value={formData[item.key] || ""}
                                          required={item.required}
                                        >
                                          <option value="">-select-</option>

                                          {clientID?.map((item) => (
                                            <option key={item.client_id} value={item.client_id}>
                                              {item.client_name}
                                            </option>
                                          ))}
                                        </select>
                                      ) : (
                                        <input
                                          className="form-control"
                                          value={formData[item.key] || ""}
                                          type={item.input}
                                          name={item.key}
                                          onChange={handleChange}
                                          required={item.required}
                                          onKeyDown={handleKeyDown}
                                        />
                                      )}
                                    </div>

                                  )
                                )}
                              </div>
                            </div>
                        </div>
                        <div className="vendor-submit-div">
                          <button type="submit" className="btn  w-100 submit fixed-bottom">Submit</button>
                        </div>
                      </form>
                    </div>
                  </div>
              </div>
          </div>
      </>
    )}
    {loginReleaseView && (
  <>
    <div className="vendorAddSingleMainContainer"></div>

    <div className="vendorAddSingleMainContainer-module shadow">
      {/* Header */}
      <div className="create-vendor-forms-header d-flex justify-content-between">
        <div>
          <h5>Login Release</h5>
          <p>Release or re-release vendor logins based on their approval status.</p>
        </div>

        <div>
          <button
            className="into-btn-icon"
            onClick={() => setLoginReleaseView(false)}
          >
            <img src={intomarkIcon} alt="" />
          </button>
        </div>
      </div>

      <div className="table-loginRelease">
        <div className="table-responsive">
          <table  className='table p-0 m-0 table-bordered'>
            <thead className=" sticky-top">
              <tr>
                <th style={{ width: "60px" }}>
                  <input
                    type="checkbox"
                    checked={selectedVendors.length === getData.length}
                    onChange={handleSelectAll}
                  />
                </th>
                <th>Vendor ID</th>
                <th>Organization ID</th>
                <th>Vendor Name</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {getData?.map((row) => (
                <tr key={row.id}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedVendors.includes(row.id)}
                      onChange={() => handleSelect(row.id)}
                    />
                  </td>

                  <td>{row.vendor_id}</td>
                  <td>{row.client_id}</td>
                  <td>{row.vendor_name}</td>

                  <td>
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => handleSingleRelease(row.id)}
                    >
                      {row.releaseStatus === 1 ? "Re-Release" : "Release"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Release Selected Button */}
        </div>
      </div>
          <div className="text-end mt-3">
            <button
              className="btn btn-success"
              disabled={selectedVendors.length === 0}
              onClick={handleBulkRelease}
            >
              Release Selected ({selectedVendors.length})
            </button>
          </div>
    </div>
  </>
)}

    </div>
  )
}

export default Vendor